import { Component } from "@angular/core";
import { Subscription } from "rxjs";
import { ApiResponse, FetchResponse } from "../../models/api-response.interface";
import { Category } from "src/app/features/product-list/models/category-interface";
import { CategoryApiService } from "src/app/features/product-list/services/category-api.service";

@Component({
  selector: "app-main-layout",
  templateUrl: "./main-layout.component.html",
  styleUrl: "./main-layout.component.scss",
  standalone: false,
})
export class MainLayoutComponent {
  subscription: Subscription = new Subscription();
  categories!: FetchResponse<Category[]>;
  constructor(private categoryApiService: CategoryApiService) {}
  ngOnInit(): void {
    this.fetchCategories();
  }

  fetchCategories() {
    this.subscription.add(
      this.categoryApiService.fetchCategories().subscribe({
        next: (res: ApiResponse<FetchResponse<Category[]>>) => {
          this.categories = res.data;
        },
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
